// extracted by mini-css-extract-plugin
module.exports = {"container":"VfcmhsEGZKd2gqkgSxy4R"};